import { FormControl, styled } from "@mui/material";
import { simpleSelectName } from "../classes.js";
const Root = styled(FormControl, {
  name: simpleSelectName,
  slot: "Root",
  overridesResolver: (_props, styles) => [styles.root]
})(() => ({
  // see form-ui/src/fields/primitives/FormUIFormControl.tsx
  marginTop: 5
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
